import { requestMethod } from "../../../config/constants";
import envConfig from "../../../env.config";
import { fetch } from "../../../shared/services/api.service";
import { checkApiSuccess } from "../../../utils";

export const addNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/addNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const addNodeEdge = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/addNodeEdge`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateNodeEdge = async (payload) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/updateNodeEdge`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const deleteNodeEdge = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/deleteNodeEdge`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const deleteNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/deleteNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getNodesAndEdges = async (workflowId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/getNodesAndEdges`,
    params: { workflowId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const addUpdateWorkflowNodesView = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/addUpdateWorkflowNodesView`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getWorkflowNodesView = async (workflowId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/getWorkflowNodesView`,
    params: { workflowId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${envConfig.BASE_URL.BASE_API_URL}/workflowNodes/updateNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};


export const addTaskNodes = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url:  `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/addTaskNodes`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data[0];
    }
  };
};


export const getTaskNodesAndEdges = async (taskId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/getTaskNodesAndEdges`,
    params: { taskId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const addTaskNodeEdge = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/addTaskNodeEdge`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateTaskNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/updateTaskNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const deleteTaskNodeEdge = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/deleteTaskNodeEdge`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const addTaskNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/addTaskNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const deleteTaskNode = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${envConfig.BASE_URL.BASE_API_URL}/taskNodes/deleteTaskNode`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};